import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";

import { SNOOZE_DEPARTMENTS } from "models";

import type { DropdownItemProps } from "components/Dropdown";

export const DepartmentFilter = () => {
  const { t } = useTranslation();

  const [selectedDepartment, setSelectedDepartment] = useState<SNOOZE_DEPARTMENTS | undefined>(undefined);

  const departmentsOptions: DropdownItemProps[] = useMemo(
    () => [
      { key: SNOOZE_DEPARTMENTS.Sales, value: SNOOZE_DEPARTMENTS.Sales, text: t("v8_sales", "Sales") },
      { key: SNOOZE_DEPARTMENTS.CCC, value: SNOOZE_DEPARTMENTS.CCC, text: t("v8_ccc", "CCC") },
      { key: SNOOZE_DEPARTMENTS.BodyRepair, value: SNOOZE_DEPARTMENTS.BodyRepair, text: t("v8_body_repair", "Body repair") },
      { key: SNOOZE_DEPARTMENTS.External, value: SNOOZE_DEPARTMENTS.External, text: t("v8_external", "External") },
      { key: SNOOZE_DEPARTMENTS.Digital, value: SNOOZE_DEPARTMENTS.Digital, text: t("v8_digital", "Digital") },
      { key: SNOOZE_DEPARTMENTS.Parts, value: SNOOZE_DEPARTMENTS.Parts, text: t("v8_parts", "Parts") }
    ],
    []
  );

  return (
    <div>
      <Dropdown
        selectOnBlur={false}
        placeholder={t("v8_department", "Department")}
        value={selectedDepartment}
        onChange={(_e, data) => setSelectedDepartment(data.value as SNOOZE_DEPARTMENTS)}
        selection
        options={departmentsOptions}
      />
    </div>
  );
};
